export default "__VITE_ASSET__0DIXE7Jj__";